export const UPDATE = "audiences/UPDATE";
export const APPEND = "audiences/APPEND";
export const UPDATE_ONE = "audiences/UPDATE_ONE";
export const DESTROY = "audiences/DESTROY";
export const LOADING = "audiences/LOADING";
